import { createSelector, MemoizedSelector } from '@ngrx/store';
import { CityState, StateWithCity } from '../city-state';
import { getCityState } from './feature.selector';

export const getCurrentCityState: MemoizedSelector<StateWithCity, CityState['city']> = createSelector(
  getCityState,
  (state: CityState) => state.city,
);

export const getNoDeliveryIsShowingValue: MemoizedSelector<StateWithCity, boolean> = createSelector(
  getCurrentCityState,
  (state: CityState['city']) => state.noDeliveryIsShowing,
);
